(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["roverie-product-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('roverie-nav-close')) {
  customElements.define('roverie-nav-close', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.querySelector('button').addEventListener('click', () => {
        const drawer = this.closest('menu-drawer');
        if (!drawer) return;
        drawer.dispatchEvent(new CustomEvent('drawer:force-close', { bubbles: true }));
        drawer.querySelector('summary')?.focus();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
